<div class="inner-detalhes">
  <h3 class="uppercase">Destinatário</h3>
  <hr>
    <app-icone-descricao
      [Icone]="'fas fa-warehouse'"
      [Titulo]="tipo"
      [Descricao]="razaoSocial">
    </app-icone-descricao>
  
    <div class="info-group">
      <span>Endereço:</span>
      <p>{{endereco}}</p>
    </div>
  
    <div class="inline-items">
      <div class="info-group">
        <span>Bairro:</span>
        <p>{{bairro}}</p>
      </div>
      <div class="info-group">
        <span>Cidade:</span>
        <p>{{cidade}}</p>
      </div>
    </div>
  
    <div class="inline-items">
      <div class="info-group">
        <span>UF:</span>
        <p>{{uf}}</p>
      </div>
      <div class="info-group">
        <span>CEP:</span>
        <p>{{cep}}</p>
      </div>
      <div class="info-group">
        <span>CNPJ:</span>
        <p>{{cgc ? cgc : 'Sem informação'}}</p>
      </div>
    </div>

    <div class="inline-items">
      <div class="info-group">
        <span>Telefone 01:</span>
        <p>{{telefone ? telefone : 'Sem informação'}}</p>
      </div>
      <div class="info-group">
        <span>Telefone 02:</span>
        <p>{{telefone2 ? telefone2 : 'Sem informação'}}</p>
      </div>
      <div class="info-group">
        <span>Telefone 03:</span>
        <p>{{telefone3 ? telefone3 : 'Sem informação'}}</p>
      </div>
    </div>
  </div>
  